import store from '../configuration/store';

export class DataStorage {
    static isStorageAvailable() {
        const test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }

    static clear() {
        if (!DataStorage.isStorageAvailable()) return;
        localStorage.clear();
    }
    static setItem(key, value) {
        if (!DataStorage.isStorageAvailable()) return;
        localStorage.setItem(key, value);
    }
    static getItem(key) {
        if (!DataStorage.isStorageAvailable()) return;
        return localStorage.getItem(key);
    }

    static getRole() {
        let raw = DataStorage.getItem('role');
        if (raw) {
            return raw;
        }

        const state = store.getState();
        if (!state) return undefined;

        const { identity } = state;
        if (!identity) return undefined;

        const { role } = identity;
        if (!role) return undefined;

        return JSON.stringify(role);
    }
}



// WEBPACK FOOTER //
// ./src/utilities/storage.jsx